import React from 'react';
import { Page as PdfPage } from '@react-pdf/renderer';

const Page = ({ className, pdfMode, orientation = 'landscape', children }) => {
  return (
    <>
      {pdfMode ? (
        <PdfPage size='A3' orientation={orientation} style={className} wrap>
          {children}
        </PdfPage>
      ) : (
        // The preview has no pages and fills the drawer in both modes, so it
        // stays exactly as it was; orientation only changes the exported PDF.
        <div
        style={className}>{children}</div>
      )}
    </>
  );
};

export default Page;
